<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver">
    <div class="iq-card-body ">
      <b-form @submit.prevent="handleSubmit(submit)" ref="HolidaysForm">
        <div class="iq-card-header ">
          <div class="iq-header-title d-flex justify-content-between">
            <h4 class="card-title">
              {{ pageTitle }}
            </h4>
            <div v-if="pageTitle === 'Edit Holiday'">
              <b-button
                variant="primary"
                @click="$emit('showAddChanged', !showAdd)"
                ><i class="ion-plus"></i
              ></b-button>
            </div>
          </div>
        </div>

        <FormGenerator
          :Fields="fields"
          :model="formData"
          :options="options"
          globalClass="w-100"
        />
        <div>
          <b-spinner
            v-if="loading"
            variant="primary"
            label="Spinning"
          ></b-spinner>
          <button v-else type="submit" class="btn btn-primary">
            {{ buttonName }}
          </button>
        </div>
      </b-form>
    </div>
  </ValidationObserver>
</template>
<script>
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import { Fields, options, models } from "./form_fields";
import { getHolidayData } from "@/API/HolidaysAPIs";
import moment from "moment";
export default {
  name: "Form",
  components: {
    FormGenerator
  },
  props: [
    "id",
    "pageTitle",
    "buttonName",
    "isInList",
    "model",
    "businessId",
    "isCreateMode",
    "loading",
    "showAdd"
  ],
  data() {
    return {
      formData: JSON.parse(JSON.stringify(models)),
      options,
      fields: Fields,
      emptyModel: null
    };
  },
  async created() {
    await this.loadData();
  },
  async mounted() {
    const defaultDateRange = [
      moment().toDate(),
      moment()
        .add(1, "days")
        .toDate()
    ];
    models.dateRange = defaultDateRange;
    this.emptyModel = models;

    this.formData.business_id = this.businessId;
    this.formData.dateRange = this.formData.dateRange || defaultDateRange;
    if (this.formData.id) {
      this.formData.dateRange = [
        this.formData.dateRange[0]
          ? moment(this.formData.dateRange[0]).toDate()
          : defaultDateRange[0],
        this.formData.dateRange[1]
          ? moment(this.formData.dateRange[1]).toDate()
          : defaultDateRange[1]
      ];
    } else {
      this.formData.dateRange = defaultDateRange;
    }
  },
  watch: {
    async id(val) {
      if (this.id) this.formData = await getHolidayData(val);
    },
    model: {
      deep: true,
      handler(value) {
        this.formData = { ...this.formData, ...value };
        this.formData.dateRange = {};
        this.formData.dateRange = [
          value.from ? moment(value.from).toDate() : moment().toDate(),
          value.to
            ? moment(value.to).toDate()
            : moment()
                .add(1, "days")
                .toDate()
        ];
      }
    }
  },
  methods: {
    submit() {
      const startDate = moment(this.formData.dateRange[0]);
      const endDate = moment(this.formData.dateRange[1]);
      this.formData.from = startDate.format("YYYY-MM-DD 14:00:00");
      this.formData.to = endDate.format("YYYY-MM-DD 14:00:00");
      this.formData.dateRange = {
        startDate: moment(this.formData.from).toISOString(),
        endDate: moment(this.formData.to).toISOString()
      };

      this.formData.business_id = this.businessId;
      this.$emit("submit", this.formData);
    },
    resetForm() {
      if (this.emptyModel) {
        this.formData = JSON.parse(JSON.stringify(this.emptyModel));
        this.$refs.validationObserver && this.$refs.validationObserver.reset();
      } else {
        console.error("emptyModel is not defined");
      }
    },
    async loadData() {
      if (!this.id) this.id = this.$route.params.id;
      if (this.id) this.formData = await getHolidayData(this.id);
      if (this.model) this.formData = { ...this.model };
      if (this.createForm) {
      }
    }
  }
};
</script>
<style scoped></style>
